import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  RequisicaoManifestoConsulta,
  ManifestoConsulta,
  CancelarManifestoTransferenciaRequest,
  CancelarManifestoTransferenciaResponse,
  ValidarManifestoTransferenciaRequest,
  ValidarManifestoTransferenciaResponse,
  AlterarManifestoRequest,
  AlterarManifestoResponse,
  VolumesQueNaoEstaoNoManifestoOutput,
  VolumesQueNaoEstaoNoManifestoInput,
  ReManifestoOutput,
} from 'src/app/@shared/models/manifesto-transferencia.model';
import { BarcodeListarRequest, BarcodeListarResponse } from 'src/app/@shared/models/selecao-volumes/selecao-volumes.model';
import { ManifestroTranferenciaPorCodigoBarrasOutput } from 'src/app/@shared/models/garagem/garagem.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const filtro = (obj: ValidarManifestoTransferenciaRequest | BarcodeListarRequest) => {
  const filtro = Object.entries(obj).filter(([k, v]) => v);
  return new URLSearchParams(filtro);
}

@Injectable({
  providedIn: 'root'
})
export class ManifestoTransferenciaService {

  private httpClient: HttpClient;

  constructor(
    handler: HttpBackend,
    private http: HttpClient
  ) {
    this.httpClient = new HttpClient(handler);
  }

  selecionarManifestoVinculadoAoContainer(containerUnique: string): Observable<HttpResponse<ReManifestoOutput>> {
    return this.http.get<ReManifestoOutput>(
      `Gaiola/SelecionarManifestoVinculadoAoContainer/${containerUnique}`,
      { observe: 'response' }
    );
  }

  validarIata(agenteId?: number): Observable<any> {
    return this.http
      .get<any>(`ManifestoTransferencia/ValidarManifestoAtivoIATA/${agenteId}`, httpOptions);
  }

  validarFilialAgente(agenteId?: number): Observable<any> {
    return this.http
      .get<any>(`ManifestoTransferencia/ValidarFilialAgenteMT/${agenteId}`, httpOptions);
  }

  consultarCapacidadeAgente(agenteId: number): Observable<any> {
    return this.http
      .get<any>(`ManifestoTransferencia/ConsultaCapacidadeAgente/${agenteId}`, httpOptions);
  }

  validarManifestoTransferencia(obj: ValidarManifestoTransferenciaRequest):
    Observable<ValidarManifestoTransferenciaResponse> {
    return this.http.get<ValidarManifestoTransferenciaResponse>(
      `ManifestoTransferencia/ValidarManifestoTransferencia?${filtro(obj)}`,
      httpOptions
    );
  }

  gerarManifesto(obj: any): Observable<any> {
    return this.http
      .post<any>(`ManifestoTransferencia/gerar`, obj, httpOptions);
  }

  consultaManifesto(obj: RequisicaoManifestoConsulta): Observable<ManifestoConsulta[]> {
    const filter = `${obj.dataInicio ? `dataInicio=${obj.dataInicio}&` : ''}` +
      `${obj.dataFim ? `dataFim=${obj.dataFim}&` : ''}` +
      `${obj.iata ? `iATA=${obj.iata}&` : ''}` +
      `${obj.numeroMT ? `numeroMT=${obj.numeroMT}&` : ''}` +
      `${obj.classe ? `classe=${obj.classe}&` : ''}` +
      `${obj.lacre ? `lacre=${obj.lacre}&` : ''}` +
      `${obj.numeroNRT ? `numeroNRT=${obj.numeroNRT}&` : ''}` +
      `${obj.recepcionado ? `recepcionado=${obj.recepcionado}&` : ''}` +
      `${obj.filialOrigem ? `filialOrigem=${obj.filialOrigem}&` : ''}` +
      `${obj.filialDestino ? `filialDestino=${obj.filialDestino}&` : ''}` +
      `${obj.semAbrangencia ? `semAbrangencia=${obj.semAbrangencia}&` : ''}` +
      // novoscampos
      `${obj.iataCorredor ? `iataCorredor=${obj.iataCorredor}&` : ''}` +
      `${obj.corredorId ? `corredorId=${obj.corredorId}&` : ''}` +
      `${obj.gridId ? `gridId=${obj.gridId}&` : ''}` +
      `${obj.comME ? `comME=${obj.comME}&` : ''}` +
      //
      `${obj.manifTransfID ? `manifTransfID=${obj.manifTransfID}&` : ''}` +
      `${obj.paginaAtual ? `paginaAtual=${obj.paginaAtual}&` : ''}` +
      `${obj.itensPorPagina ? `itensPorPagina=${obj.itensPorPagina}` : ''}`;
    return this.http.get<ManifestoConsulta[]>(
      `ManifestoTransferencia/ConsultaMT?${filter}`,
      httpOptions
    );
  }

  public exportarExcel(obj: RequisicaoManifestoConsulta): Observable<any> {
    const filter = `${obj.dataInicio ? `dataInicio=${obj.dataInicio}&` : ''}` +
      `${obj.dataFim ? `dataFim=${obj.dataFim}&` : ''}` +
      `${obj.iata ? `iATA=${obj.iata}&` : ''}` +
      `${obj.numeroMT ? `numeroMT=${obj.numeroMT}&` : ''}` +
      `${obj.classe ? `classe=${obj.classe}&` : ''}` +
      `${obj.lacre ? `lacre=${obj.lacre}&` : ''}` +
      `${obj.numeroNRT ? `numeroNRT=${obj.numeroNRT}&` : ''}` +
      `${obj.recepcionado ? `recepcionado=${obj.recepcionado}&` : ''}` +
      `${obj.filialOrigem ? `filialOrigem=${obj.filialOrigem}&` : ''}` +
      `${obj.filialDestino ? `filialDestino=${obj.filialDestino}&` : ''}` +
      `${obj.semAbrangencia ? `semAbrangencia=${obj.semAbrangencia}&` : ''}` +
      `${obj.paginaAtual ? `paginaAtual=${obj.paginaAtual}&` : ''}` +
      `${obj.itensPorPagina ? `itensPorPagina=${obj.itensPorPagina}` : ''}`;
    return this.http.get<any>(`ManifestoTransferencia/ExportarExcel?${filter}`, httpOptions);
  }


  consultaRemanifesto(manifTransId?: number): Observable<ManifestoConsulta[]> {
    return this.http.get<ManifestoConsulta[]>(
      `ManifestoTransferencia/ConsultaRemanifestar/${manifTransId}`,
      httpOptions
    );
  }

  alterarManifesfo(obj: AlterarManifestoRequest): Observable<AlterarManifestoResponse> {
    return this.http
      .post<any>(`ManifestoTransferencia/alterar`, obj, httpOptions);
  }

  consultaAtualizacaoManifesto(manifTransId?: number): Observable<any> {
    return this.http
      .get<any>(`ManifestoTransferencia/ConsultaAtualizacaoMT/${manifTransId}`, httpOptions);
  }

  validarRemanifesto(manifTransId?: number): Observable<any> {
    return this.http
      .post<any>(`ManifestoTransferencia/ValidacaoRemanifestar/${manifTransId}`, null, httpOptions);
  }

  validarTotalManifesto(obj?: any): Observable<any> {
    const filter = `${obj.manifTransfId ? `manifTransfId=${obj.manifTransfId}` : ''}`
      + `${obj.qtdPedidos ? `&qtdPedidos=${obj.qtdPedidos}` : ''}`
      + `${obj.ehRemanifesto ? `&ehRemanifesto=true` : ''}`;
    return this.http
      .get<any>(`ManifestoTransferencia/ValidarRecepcaoTotalManifestoTransferencia?${filter}`, httpOptions);
  }

  validarUnitariaManifesto(obj?: any): Observable<any> {
    return this.http
      .post<any>(`ManifestoTransferencia/ValidarRecepcaoUnitariaManifestoTransferencia`, obj, httpOptions);
  }

  recepcionarTotalManifesto(obj?: AlterarManifestoRequest): Observable<AlterarManifestoResponse> {
    return this.http
      .post<any>(`ManifestoTransferencia/RecepcionarTotalMT`, obj, httpOptions);
  }

  recepcionarUnitarioManifesto(obj: AlterarManifestoRequest): Observable<AlterarManifestoResponse> {
    return this.http
      .post<any>(`ManifestoTransferencia/RecepcionarUnitarioMT`, obj, httpOptions);
  }

  validarRecepcaoUnitariaVolume(obj?: any): Observable<any> {
    return this.http
      .post<any>(`ManifestoTransferencia/ValidarRecepcaoUnitariaVolume`, obj, httpOptions)
  }

  receberPedidoGrid(obj?: any): Observable<any> {
    return this.http
      .post<any>(`ManifestoTransferencia/ReceberPedidosGrid`, obj, httpOptions)
  }

  validarLimite(obj?: any): Observable<any> {
    return this.http
      .post<any>(`ValidacaoValorMT/efetue-validacao`, obj, httpOptions)
  }

  cancelarManifestoTransferencia(obj: CancelarManifestoTransferenciaRequest): Observable<CancelarManifestoTransferenciaResponse> {
    return this.http.post<CancelarManifestoTransferenciaResponse>(`ManifestoTransferencia/cancelar`, obj, httpOptions);
  }

  listarVolumesNaoCompletosManifestoEmbarque(obj: VolumesQueNaoEstaoNoManifestoInput): Observable<VolumesQueNaoEstaoNoManifestoOutput> {

    return this.http.post<VolumesQueNaoEstaoNoManifestoOutput>(
      `ManifestoTransferencia/VolumesQueNaoEstaoNoManifesto`, obj,
      httpOptions
    );
  };

  barcodeListar(obj: BarcodeListarRequest): Observable<BarcodeListarResponse[]> {
    return this.http.get<BarcodeListarResponse[]>(
      `Barcode/Listar?${filtro(obj)}`,
      httpOptions
    );
  }

  barcodeListar2(obj: any): Observable<any[]> {
    return this.http.get<any[]>(
      `RecepcaoFisica/${obj.pedidoId}/Remessas`,
      httpOptions
    );
  }

  listarIatas(obj: any): Observable<any[]> {
    return this.http.get<any[]>(
      `Gaiola/ListarIatasOrigem?${filtro(obj)}`,
      httpOptions
    );
  };

  listarCorredorGrid(obj: any): Observable<any[]> {
    return this.http.get<any[]>(
      `ManifestoTransferencia/FiltroCorredor?${filtro(obj)}`,
      httpOptions
    );
  }

  listarGrid(obj: any): Observable<any[]> {
    return this.http.get<any[]>(
      `ManifestoTransferencia/FiltroGrid?${filtro(obj)}`,
      httpOptions
    );
  }

  alteracaoMTQtdPalete(obj: any): Observable<any> {
    return this.http.post<any>(
      `ManifestoTransferencia/AlteracaoMTQtdPaletes`, obj, httpOptions
    );
  }

  consultaManifestoPedidosVolume(obj: any): Observable<any> {
    const filter = `${obj.manifestoTranf ? `numeroCompletoManifesto=${obj.manifestoTranf}&` : ''}` + `${obj.lacre ? `numLacre=${obj.lacre}` : ''}`;

    return this.http.get<any>(
      `ManifestoTransferencia/PedidosVolumesManifesto?${filter}`,
      httpOptions
    );
  }


  ValidaLacre(obj: any): Observable<any> {
    const filter = `${obj.manifestoTranf ? `NumeroCompletoManifesto=${obj.manifestoTranf}&` : ''}` + `${obj.lacre ? `numLacre=${obj.lacre}&` : ''}` + `${obj.hasLacre ? `hasLacre=${obj.hasLacre}` : ''}`;
    return this.http.get<any>(`ManifestoTransferencia/validaLacre?${filter}`, httpOptions);
  }

  listarEmpresas(): Observable<any[]> {
    return this.http.get<any[]>(`EmpresaXAgente/ConsultaEmpresas`, httpOptions);
  }

  manifestoTransferenciaPorCodigoBarras(barcode: string, isPTL: boolean = false): Observable<ManifestroTranferenciaPorCodigoBarrasOutput[]>{
    return this.http.get<ManifestroTranferenciaPorCodigoBarrasOutput[]>(`ManifestoTransferencia/ManifestoTranferenciaPorCodigoBarras?barcode=${barcode}&isPTL=${isPTL}`, httpOptions);
  }

  manifestoTransferenciaImpressao(req: any): Observable<any[]>{
    return this.http.get<any[]>(`ManifestoTransferencia/manifestoTransferenciaImpressao?numeroCompletoManifesto=${req.numeroCompletoManifesto}
    &impressora=${req.impressora}`, httpOptions);

  }



}
